import React from 'react';
import { Button, Space, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FaWater, FaFlask, FaLeaf } from 'react-icons/fa';
import { GiGroundSprout } from 'react-icons/gi';
import { useSelector } from 'react-redux';

const AnalysisBtns = ({ exploitationId, supportedAnalysis }) => {
  const navigate = useNavigate();
  const userRole = useSelector((state) => state.user.userRole.name);

  const userLink = () => {
        if (userRole === 'client') {
          return '/client';
        } else if (userRole === 'admin' || userRole === 'superadmin') {
          return '/admin';
        } else if (userRole === 'domain_manager') {
          return '/domain-manager';
        } else if (userRole === 'exploitation_manager') {
          return '/exploitation-manager';
        }
      };
  const analysisTypes = [
    { key: 'sol', label: 'Sol', icon: GiGroundSprout, color: '#faad14' },
    { key: 'eau', label: 'Eau', icon: FaWater, color: '#1890ff' },
    { key: 'solution-sol', label: 'Solution du sol', icon: FaFlask, color: '#eb2f96' },
    { key: 'feuilles', label: 'Feuilles', icon: FaLeaf, color: '#52c41a' }
  ];

  if (!supportedAnalysis) return null;
  
  const supportedAnalysisArray = supportedAnalysis?.split(',').filter(analysis => analysis.trim());

  const filteredAnalysisTypes = analysisTypes.filter(type => 
    supportedAnalysisArray.includes(type.key)
  );

  const handleAnalysisClick = (analysisType) => {
    navigate(`${userLink()}/exploitation/${exploitationId}/analysis/${analysisType}`);
  };

  return (
    <Space size="small" wrap>
      {filteredAnalysisTypes.map((type) => (
        <Tooltip key={type.key} title={type.label}>
          <Button
            type="primary"
            icon={<type.icon style={{ fontSize: '24px' }} />}
            onClick={() => handleAnalysisClick(type.key)}
            style={{ backgroundColor: type.color, borderColor: type.color }}
            className="hover:opacity-80 transition-opacity duration-300"
          />
        </Tooltip>
      ))}
    </Space>
  );
};

export default AnalysisBtns;